export const ceremonyMap: Map<string, Map<string, string>> = new Map([
  [
    '2026-05-27 10:00',
    new Map([
      ['School of Engineering and Schwarzman College of Computing Advanced Degree Ceremony', '107'],
      ['School of Science Advanced Degree Ceremony', '110']
    ])
  ],
  [
    '2026-05-28 10:00',
    new Map([
      ['OneMIT Commencement Ceremony', '105'],
      ['School of Architecture and Planning Advanced Degree Ceremony', '108'],
      ['School of Humanities, Arts, and Social Sciences Advanced Degree Ceremony', '109'],
      ['Sloan School of Management Master of Finance Ceremony', '113'],
      ['Sloan School of Management Doctoral Hooding Ceremony', '114'],
      ['Sloan School of Management Executive MBA Ceremony', '115']

    ])
  ],
  [
    '2026-05-29 10:00',
    new Map([
      ['Undergraduate Degree Ceremony', '106'], ['Sloan School of Management MIT Sloan Fellows MBA Ceremony', '111'],
      ['Sloan School of Management MBA and Master of Science Management Studies Ceremony', '116']
    ])
  ]
])

export const flatMap: Map<string, string> = new Map(
  Array.from(ceremonyMap.values()).flatMap((innerMap) =>
    Array.from(innerMap.entries())
  )
);
